import { useEffect } from 'react';

import { useClientStorageItem } from '@/entities/clientStorage';

import { RECORDING_SURVEY_STORAGE_KEY } from '../lib/constants';
import { useRecordingWelcomeSurveyStore } from './useRecordingWelcomeSurveyStore';

export const useArmRecordingWelcomeSurvey = () => {
  const isArmed = useRecordingWelcomeSurveyStore((s) => s.isArmed);
  const openSurvey = useRecordingWelcomeSurveyStore((s) => s.open);
  const disarm = useRecordingWelcomeSurveyStore((s) => s.disarm);

  const { data, isError, isLoading } = useClientStorageItem(RECORDING_SURVEY_STORAGE_KEY, {
    enabled: isArmed,
  });

  useEffect(() => {
    if (!isArmed) return;

    if (isLoading) return;

    if (isError) {
      disarm();
      return;
    }

    if (data === null || data.value !== 'true') {
      openSurvey();
      disarm();
      return;
    }

    disarm();
  }, [data, disarm, isArmed, isError, isLoading, openSurvey]);
};
